/**
 * Available backend versions/types
 */
export enum BackEndApiType {
	Unknown = 0,
	Evolution = 1,
	WebApi = 2,
	/** Combination of B2C and WebApi. The user will login with B2C but the WebApi will transform the B2C user to the usermodule user. */
	B2C = 3,
}
